import { render, staticRenderFns } from "./loginDev.vue?vue&type=template&id=6f817f0c&scoped=true&"
import script from "./loginDev.vue?vue&type=script&lang=js&"
export * from "./loginDev.vue?vue&type=script&lang=js&"
import style0 from "./loginDev.vue?vue&type=style&index=0&id=6f817f0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f817f0c",
  null
  
)

export default component.exports